const spayedFactor = {
    "yes": 1,
    "no": 1.1
};

const caloriesFactor = {
  "cat": {
    "junior": 109.3,
    "adult": 109.4,
    "senior": 109.4
  },
  "dog": {
    "junior": 113,
    "adult": 85.4,
    "senior": 85.4
  }
}

const activityFactor = {
    "low": 1.2,
    "medium": 1.4,
    "high": 1.6
};

const bodyConditionFactor = {
    "1": 1.2,
    "2": 1.1,
    "3": 1,
    "4": 0.9,
    "5": 0.8
};

let petDetails = {};
let productRecommendations = [];
let calculationDetail = {};
const bodyCondition = [
    "Severely Underweight",
    "Underweight",
    "Normal",
    "Overweight",
    "Obese"
];

const activity = {
  "cat": [
    "Low - Mostly lazes around",
    "Med - Runs and plays occasionally",
    "High - Always running and playing"
  ],
  "dog": [
    "Low - Up to 60 min of walking/ day",
    "Med - 1-2 hour walks/day",
    "High - More than 2 hour walks/day"
  ]
};

const initialWeight = (species, type, weight) => {
    let basicFactor = {
      "cat": 70,
      "dog": 70
    };
  
    let basicCalories = basicFactor[species] * (Math.pow(weight, 0.75));
    if (type === 'junior') {
        return basicCalories * 2;   
    }

    return basicCalories;
}

function roundToHalf(num) {
    return Math.round(num * 2) / 2;
}

const getCaloriesFactor = (species, type) => {
  return caloriesFactor[species][type];
}

const calculateCalories = () => {
    const species = document.querySelectorAll('[name="species"]');
    const petname = document.querySelector('[name="petname"]');
    const resultTitle = document.querySelector('.result-title');
    const weight = document.querySelector('[name="weight"]');

    const age = document.querySelector('[name="age"]');
    const bodyConditions = document.querySelectorAll('[name="body-condition"]');
    const neutered = document.querySelector('[name="neutered"]');
    const activities = document.querySelectorAll('[name="activity"]');
    const currentValue = document.querySelector('.current-weight > .value');
    // const idealValue = document.querySelector('.ideal-weight > .value');
    const caloriesValue = document.querySelector('.calories > .value');
    const cubesValue = document.querySelector('.cubes > .value');
    const bodyWeight = document.querySelector('.body-weight');

    let speciesValue = "dog";
    for (var i=0, n=species.length;i<n;i++) 
    {
        if (species[i].checked) 
        {
            speciesValue = species[i].value;
        }
    }
    const weightRanges = {
        "dog": [
            { maxAge: 1, min: 2, max: 10 },   // Puppy
            { maxAge: 3, min: 10, max: 25 },  // Young adult
            { maxAge: 7, min: 20, max: 35 }, // Adult
            { maxAge: 12, min: 18, max: 30 } // Senior
        ],
        "cat": [
            { maxAge: 1, min: 1, max: 3 },   // Kitten
            { maxAge: 3, min: 3, max: 5 },   // Young adult
            { maxAge: 7, min: 4, max: 6 },   // Adult
            { maxAge: 12, min: 3, max: 5 } // Senior
        ]
    };
    const ageRange = weightRanges[speciesValue].find(range => parseInt(age.value) <= range.maxAge);
    // const idealMinWeight = ageRange.min;
    // const idealMaxWeight = ageRange.max;
    // const currentWeightPercentage = 
    //         ((parseInt(weight.value) - idealMinWeight) / (idealMaxWeight - idealMinWeight)) * 100;

    // // Determine health status
    // let healthStatus = 'Ideal Weight';
    // if (currentWeightPercentage < 0) {
    //     healthStatus = `${Math.abs(currentWeightPercentage.toFixed(0))}% under Ideal weight`;
    // } else if (currentWeightPercentage > 110) {
    //     healthStatus = `${currentWeightPercentage.toFixed(0)}% over Ideal weight`;
    // } else {
    //   bodyWeight.classList.add('ideal');
    //   currentValue.classList.add('ideal');
    // }

    let type = 'junior';
    const ageOption = parseInt(age.value);

    if (ageOption > 0 && ageOption <= 8) {
      type = 'adult';
    } else if (ageOption > 8) {
      type = 'senior';
    }

    console.log(type);
    let body_condition = "0";
    let activity = "0";
  
    for (var i=0, n=bodyConditions.length;i<n;i++) 
    {
        if (bodyConditions[i].checked) 
        {
            body_condition = bodyConditions[i].value;
        }
    }
    
    for (var i=0, n=activities.length;i<n;i++) 
    {
        if (activities[i].checked) 
        {
            activity = activities[i].value;
        }
    }
    let calories = initialWeight(speciesValue, type, weight.value);

    console.log('initial:' + calories);
    calories = calories * spayedFactor[neutered.value];
    console.log('spayed:' + calories);
    calories = calories * bodyConditionFactor[body_condition];
    console.log('body condition:' + calories);
    
    if (speciesValue === 'dog') {
      calories = calories * activityFactor[activity];
      console.log('activity:' + calories);
    }
  
    currentValue.innerHTML = `${weight.value}kg`;
    // idealValue.innerHTML = `${idealMinWeight}-${idealMaxWeight}kg`;
    caloriesValue.innerHTML = `${calories.toFixed(0)}kcal`;

    let cubes = 0;
  console.log(speciesValue);
    if (speciesValue === 'dog') {
      cubes = (parseInt(calories)/getCaloriesFactor(speciesValue, type)).toFixed(0);
    } else {
      cubes = roundToHalf((parseInt(calories)/getCaloriesFactor(speciesValue, type)));
      console.log(cubes);
    }
    cubesValue.innerHTML = `${cubes} ${cubes > 1 ? 'cubes' : 'cube'}`;
    // bodyWeight.innerHTML = `${healthStatus}`;

    calculationDetail['currentValue'] = currentValue.innerHTML;
    calculationDetail['caloriesValue'] = caloriesValue.innerHTML;
    calculationDetail['cubesValue'] = cubesValue.innerHTML;

    resultTitle.innerHTML = `Here’s our customised feeding plan for ${petname.value}`;

}

function generateProductTable(products) {
  console.log(products);
  const columnWidth = Math.floor(100 / 3); // Calculate width for 3 columns
  const cells = products.map(product => 
    `<td width="${columnWidth}%" align="center" style="padding:5px;vertical-align:top;"><img src="${product.image}" alt="${product.name}" width="128" height="128" style="max-width:100%;height:auto; margin-bottom:-12px"><p style="color:#666;font-size:14px;line-height:1.3;margin:10px 0">${product.name}</p></td>`
  ).join('');
  
  return `<table border="0" cellpadding="0" cellspacing="0" width="100%"><tr>${cells}</tr></table>`;
}

function generatePetDetailsTable(petData) {
  const mapping = {
    'petname': 'Name',
    'species': 'Species',
    'age': 'Age',
    'weight': 'Bodyweight',
    'body-condition': 'Body condition',
    'activity': 'Activity level',
    'neutered': 'Neutered / Spayed',
    'allergies': 'Allergies'
  };

  return Object.entries(mapping)
    .map(([key, label]) => 
      `<tr><td style="color:#666;font-weight:bold;font-size:12px;line-height:16px;padding:2px 0"><span style="display:inline-block;width:140px">${label}</span></td><td style="text-transform:capitalize; font-size: 12px;">: ${petData[key]}</td></tr>`
    )
    .join('');
}

const printHTML = () => {
  const cssUrl = ""
  const petName = petDetails.petname;
  const species = petDetails.species;
  const petImage = `https://www.petcubes.com/cdn/shop/t/115/assets/top-${species}.png`
  const productTable = generateProductTable(productRecommendations);
  const petDetailHTML = generatePetDetailsTable(petDetails);
  const minifyHTML = `<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Feeding Calculator Results</title><link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap" rel="stylesheet"><link href="https://fonts.cdnfonts.com/css/more-sugar" rel="stylesheet"><style>body{margin:0;padding:0;background-color:#fff;font-family:Poppins,system,sans-serif}@page{size:A5 portrait;margin:0}@media print{.print-container{transform: scale(0.90);width:148mm;height:210mm;margin:0 auto;page-break-after:avoid}@media not all and (min-resolution:.001dpcm){@supports (-webkit-appearance:none){.print-container{transform: scale(0.90);width:148mm;height:210mm}}}@media screen and (-webkit-min-device-pixel-ratio:0){@supports (not (-webkit-touch-callout:none)){.print-container{width:148mm;height:210mm}}}@supports (-webkit-touch-callout:none){.print-container{transform:scale(.90);transform-origin:top left}}}</style></head><body><div class="print-container"><table border="0" cellpadding="0" cellspacing="0" width="85%" style="max-width:600px;margin:0 auto"><tr><td style="padding:10px"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td width="48"><img src="https://www.petcubes.com/cdn/shop/t/115/assets/petcubes-logo-2.png?v=148794154900949279151741570581" alt="Pet Cubes" width="48" height="48" style="display:block"></td><td style="padding-left:15px"><h2 style="color:#29b589;font-size:21px;line-height:48px;font-weight:500;font-family:'More Sugar',system,sans-serif">FEEDING CALCULATOR RESULTS</h2></td></tr></table><table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;margin:0 auto"><tr><td style="padding:10px"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td width="100%" style="text-align:center"><img src="${petImage}" alt="Pet Species" width="auto" height="96" style="margin:0 auto; margin-top: -16px;"></td></tr></table><table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="D9EFEA" style="margin-top:0;border-radius:8px"><tr><td style="padding:10px"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td style="color:#29b589;font-size:18px;padding-bottom:10px"><h3 style="margin:0;font-weight:500;font-family:'More Sugar',system,sans-serif">Your Pet's Details:</h3></td></tr>${petDetailHTML}</table></td></tr></table><table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:6px"><tr><td><h3 style="color:#29b589;font-size:18px;padding-bottom:6px;margin:0;font-weight:500;line-height:1;font-family:'More Sugar',system,sans-serif">Here is our customised feeding plan for ${petName}!</h3></td></tr><tr><td style="color:#666;font-size:16px;padding-bottom:10px;font-weight:400;font-family:Poppins,system,sans-serif"><h4 style="margin:0;line-height:1.25;font-size:14px">Base on what you have entered, we recommend the following feeding plan:</h4></td></tr></table><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td width="33.33%" style="vertical-align:top"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td style="color:#666;font-weight:400;font-size:14px;font-family:'More Sugar',system,sans-serif"><strong>Current:</strong></td></tr><tr><td style="color:#29b589;font-weight:400;font-size:18px;font-weight:700;font-family:'More Sugar',system,sans-serif">${calculationDetail.currentValue}</td></tr></table></td><td width="33.33%" style="vertical-align:top"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td style="color:#666;font-weight:400;font-size:14px;font-family:'More Sugar',system,sans-serif"><strong>Recommended Daily<br/>Calories:</strong></td></tr><tr><td style="color:#29b589;font-weight:400;font-size:18px;font-weight:700;font-family:'More Sugar',system,sans-serif">${calculationDetail.caloriesValue}</td></tr></table></td><td width="33.33%" style="vertical-align:top"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td style="color:#666;font-weight:400;font-size:14px;font-family:'More Sugar',system,sans-serif"><strong>PetCubes<br>to feed (Per day):</strong></td></tr><tr><td style="color:#29b589;font-weight:400;font-size:18px;font-weight:700;font-family:'More Sugar',system,sans-serif">${calculationDetail.cubesValue}</td></tr></table></td></tr></table><table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-top:6px"><tr><td style="color:#666;font-weight:400;font-size:16px;padding-bottom:2px;font-family:'More Sugar',system,sans-serif"><strong>Recommended Products:</strong></td></tr></table>${productTable}</td></tr></table></td></tr></table></div></body></html>`;
  const printWindow = window.open('', '');
  printWindow.document.write(minifyHTML);
  printWindow.document.close();
  printWindow.focus();

  printWindow.onload = () => {
    const images = printWindow.document.images;
    const totalImages = images.length;
    let loadedCount = 0;
    const timeout = 5000; // 5 seconds max wait
    let fallbackTimeout; // Declare it here so it's accessible

    const checkAndPrint = () => {
      if (loadedCount === totalImages) {
        clearTimeout(fallbackTimeout);
        printWindow.print();
        printWindow.close();
      }
    };

    if (totalImages === 0) {
      printWindow.print();
      printWindow.close();
      return;
    }

    for (let img of images) {
      if (img.complete) {
        loadedCount++;
        checkAndPrint();
      } else {
        img.onload = () => {
          loadedCount++;
          checkAndPrint();
        };
        img.onerror = () => {
          loadedCount++;
          checkAndPrint();
        };
      }
    }

    // Now assign the timeout AFTER it's declared
    fallbackTimeout = setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, timeout);
  };
}
const sendEmail = async () => {
  let htmlContent = document.getElementById('results').innerHTML;
  let toAddress = document.querySelector('[name="email"]').value;
  try {
    const response = await fetch('https://www.petcubes.com/apps/email', {
      method: 'POST',
      body: JSON.stringify({
        toAddress: toAddress,
        productRecommendations: productRecommendations,
        petDetails: petDetails,
        calculationDetail: calculationDetail
      })
    });
    
    const result = await response.text();
    return result;
  } catch (error) {
    console.error('error:', error);
    throw error;
  }
}

const isFormValid = () => {
    let valid = true;
    const requiredFields = ['petname', 'age', 'weight', 'neutered'];
    requiredFields.forEach(element => {
        const input = document.querySelector(`[name="${element}"]`);
        const inputLabel = document.querySelector(`.${element}-label`);
        if (input.value === null || input.value === "") {
            input.classList.add('error');
            inputLabel.classList.add('error');
            valid = false;
        } else {
          input.classList.remove('error');
          inputLabel.classList.remove('error');
        }
    });

    return valid;
}

const openConfirmation = (target) => {
   const overlay = document.querySelector('.confirmation-overlay');
   const confirmationBox = document.querySelector(`.confirmation-${target}`);
   const resetYes = document.querySelector(`.confirmation-reset .btn-green`);
   const okThankYou = document.querySelector(`.confirmation-thank-you .btn-green`);
   const okEmail = document.querySelector(`.confirmation-email .btn-green`);
   const resetNo = document.querySelector(`.confirmation-reset .btn-grey`);
   const body = document.querySelector('.body');
  const mainForm = document.querySelector('.main-form');
   overlay.classList.remove('d-none');
   // overlay.style.top = `${window.scrollY}px`;
   confirmationBox.classList.remove('d-none');
   body.classList.add('overflow-hidden');
   body.classList.add('position-fixed');

  resetNo.addEventListener('click', () => {
    confirmationBox.classList.add('d-none');
    body.classList.remove('overflow-hidden');
    overlay.classList.add('d-none');
    body.classList.remove('position-fixed');
  })

  resetYes.addEventListener('click', () => {
    toggleSpeciesHandler('dog');
    resetAllergies();
    confirmationBox.classList.add('d-none');
    body.classList.remove('overflow-hidden');
    body.classList.remove('position-fixed');
    overlay.classList.add('d-none');
    document.querySelector('.main-form').reset();
    window.scrollTo({top: 0, behavior: 'smooth'});
  })

  okThankYou.addEventListener('click', () => {
    const calculator = document.getElementById('calculator');
    const result = document.getElementById('results');
    toggleSpeciesHandler('dog');
    resetAllergies();
    mainForm.reset();
    result.classList.add('d-none');
    calculator.classList.remove('d-none');
    confirmationBox.classList.add('d-none');
    body.classList.remove('overflow-hidden');
    body.classList.remove('position-fixed');
    overlay.classList.add('d-none');
    window.scrollTo({top: 0, behavior: 'smooth'});
  })

  okEmail.addEventListener('click', () => {
    const calculator = document.getElementById('calculator');
    const result = document.getElementById('results');
    toggleSpeciesHandler('dog');
    resetAllergies();
    mainForm.reset();
    result.classList.add('d-none');
    calculator.classList.remove('d-none');
    confirmationBox.classList.add('d-none');
    body.classList.remove('overflow-hidden');
    body.classList.remove('position-fixed');
    overlay.classList.add('d-none');
    window.scrollTo({top: 0, behavior: 'smooth'});
  })
}

const toggleDetail = document.getElementById('toggle-detail');
const toggleClose = document.querySelector('.toggle-close');
const allergies = document.querySelectorAll(`[name="allergies[]"]`);

const resetAllergies = () => {
    allergies.forEach(element => {
        if (element.value !== 'none') {
            element.checked = false;
        }
    })
}

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

const toggleSpeciesHandler =  (toggle) => {
    const petDetail = document.querySelector('.pet-detail');
    const petDetailWrapper = document.querySelector('.pet-detail-wrapper');
    const toggleSpecies = document.querySelectorAll('[data-toggle="species"]');
    toggleSpecies.forEach(el => {
      if (el.hasAttribute('src')) {
        el.src = `${el.dataset[toggle]}`;
      } else {
        el.innerHTML = `${el.dataset[toggle]}`;
      }
    });
    petDetail.classList.remove('dog', 'cat');
    petDetail.classList.add(toggle);
    petDetailWrapper.classList.add(toggle);
}

allergies.forEach(element => {
    element.addEventListener('click', function(e) {
        if (element.value === 'none') {
            resetAllergies();
        } else {
            document.getElementById('allergy-none').checked = false;
        }
    })
})
toggleClose.addEventListener('click', e => {
    const petDetail = document.querySelector('.pet-detail');
    const wrapper = document.querySelector('.pet-detail-wrapper');
    const body = document.querySelector('.body');
    wrapper.classList.add('enter');
    body.classList.remove('overflow-hidden');
    body.classList.remove('position-fixed');
    setTimeout(() => {
        petDetail.classList.add('d-none');    
    }, 250);
    
});
toggleDetail.addEventListener('click', e => {
    e.preventDefault();
    const petDetail = document.querySelector('.pet-detail');
    const body = document.querySelector('.body');
    if (petDetail.classList.contains('d-none')) {
      petDetail.classList.remove('d-none');
      setTimeout(() => {
          const enter = document.querySelector('.enter');
          enter.classList.remove('enter');
          body.classList.add('overflow-hidden');
          body.classList.add('position-fixed');
      }, 250);
    } else {
      const wrapper = document.querySelector('.pet-detail-wrapper');
      wrapper.classList.add('enter');
      body.classList.remove('overflow-hidden');
      body.classList.remove('position-fixed');
      setTimeout(() => {
          petDetail.classList.add('d-none');    
      }, 250);
    }
})

// Function to fetch data from JSON URL
async function fetchProductData(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
}

async function initializeProducts(jsonUrl, excludedIngredients = null) {
    const data = await fetchProductData(jsonUrl);
    if (data) {
        const filteredProducts = filterProducts(data, excludedIngredients);
        displayProducts(filteredProducts);
    } else {
        console.error('Failed to load product data');
        container.innerHTML = '<p>Error loading products. Please try again later.</p>';
    }
}

// Function to filter products by excluded ingredients
function filterProducts(data, excludedIngredients) {
    const age = document.querySelector('[name="age"]');
    let products = data.products.junior;
    const ageOption = parseInt(age.value);
    if (ageOption > 0 && ageOption <= 8) {
      products = data.products.adult;
    } else if (ageOption > 8) {
      products = data.products.senior;
    }

    if (!excludedIngredients) return products;
    const excludedIngredientsLower = excludedIngredients.map(ing => ing.toLowerCase());
    
    return products.filter(product => {
        const productIngredientsLower = product.ingredients.map(ing => ing.toLowerCase());
        return !productIngredientsLower.some(ingredient => 
            excludedIngredientsLower.includes(ingredient)
        );
    });
}

// Function to create and display product cards
function displayProducts(products, containerId = 'product-container') {
    const container = document.querySelector('.' + containerId);
    container.innerHTML = '';
    const limitedProducts = products.slice(0, 3);
    productRecommendations = limitedProducts;
    limitedProducts.forEach(product => {
        const card = document.createElement('div');
        card.className = 'product-card col-6 col-lg-4';
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.name;
        
        const name = document.createElement('h3');
        name.textContent = product.name;
        card.appendChild(img);
        card.appendChild(name);
        container.appendChild(card);
    });
}

function filterAndDisplay(excludedIngredients) {
    const filteredProducts = filterProducts(data, excludedIngredients);
    displayProducts(filteredProducts);
}

function getSpecies() {
  const species = document.querySelectorAll('[name="species"]');
  let value = 'dog';
  for (var i=0, n=species.length;i<n;i++) 
  {
      if (species[i].checked) 
      {
          value = species[i].value;
      }
  }

  return value;
}

function getAllergies() {
  let allergyValues = []
  for (var i=0, n=allergies.length;i<n;i++) 
  {
      if (allergies[i].checked) 
      {
          allergyValues.push(allergies[i].value);
      }
  }

  return allergyValues;
}

window.onload = () => {
    const values = document.querySelectorAll('.field-value');
    const getResultButton = document.getElementById('get-result');
    const calculator = document.getElementById('calculator');
    const result = document.getElementById('results');
    const species = document.querySelectorAll('[name="species"]');
    const bodyConditions = document.querySelectorAll('[name="body-condition"]');
    const activities = document.querySelectorAll('[name="activity"]');
    
    const mainForm = document.querySelector('.main-form');
    const petDetail = document.querySelector('.pet-detail');
    const petDetailWrapper = document.querySelector('.pet-detail-wrapper');
    const enter = document.querySelector('.enter');
    species.forEach(el => {
        el.addEventListener('click', (e) => {
          if (e.target.checked) {
            toggleSpeciesHandler(e.target.value);
          }
        });
    });
    getResultButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (isFormValid()) {
            const speciesData = getSpecies();
            const jsonURL = `https://www.petcubes.com/cdn/shop/t/115/assets/${speciesData}.json`;
            calculateCalories();
            const allergyValues = getAllergies();
            initializeProducts(jsonURL, allergyValues);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const toggleNewsletter = document.querySelectorAll('[name="newsletter"]');
            const finishButton = document.getElementById('finish');
            const printButton = document.getElementById('print');
            toggleNewsletter.forEach(el => {
                el.addEventListener('click', (e) => {
                    if (e.target.checked) {
                        const toggle = e.target.value;
                        finishButton.classList.remove('d-none');
                        if (toggle === 'no') {
                          finishButton.classList.remove('btn-green');
                          finishButton.classList.add('btn-grey');
                        } else {
                          finishButton.classList.add('btn-green');
                          finishButton.classList.remove('btn-grey');
                        }
                        finishButton.innerHTML = finishButton.dataset[toggle];
                    }
                });
            });
            values.forEach(e => {
                const target = e.dataset.target;
                let value = "";
                if (target == "allergies") {
                    for (var i=0, n=allergies.length;i<n;i++) 
                    {
                        if (allergies[i].checked) 
                        {
                            value += ", "+allergies[i].value;
                        }
                    }
                    if (value) value = value.substring(1);
                } else if (target=="body-condition"){
                    for (var i=0, n=bodyConditions.length;i<n;i++) 
                    {
                        if (bodyConditions[i].checked) 
                        {
                            value = i;
                        }
                    }
                } else if (target=="activity"){
                    for (var i=0, n=activities.length;i<n;i++) 
                    {
                        if (activities[i].checked) 
                        {
                            value = i;
                        }
                    }
                } else {
                    value = document.querySelector(`[name="${target}"]`).value;
                }

                switch (target) {
                    case "age":
                            console.log(value);
                            if (value === "0" ) {
                                value = "< 6 Months Old";
                            } else if (value==="1") {
                                value = "6 Months - 1 Year Old";
                            } else if (value==="13") {
                                value = "> 12 Years Old";
                            } else {
                                value = parseInt(value) - 1;
                                value += value === 2 ? " Year Old" : " Years Old";
                            }
                        break;
                    case "weight":
                            value += " kg";
                        break;
                    case "body-condition":
                            console.log(value);
                            value = bodyCondition[value];
                        break;
                    case "activity":
                            value = activity[speciesData][value];
                        break;
                    case 'species':
                        value = speciesData;
                    default:
                        break;
                }

                e.innerHTML = value;
                petDetails[target] = value;
            })

            if (typeof e.target.dataset.retailer === "undefined") {
              calculator.classList.add('d-none');
              result.classList.remove('d-none');
              petDetail.classList.remove('d-none');
              enter.classList.remove('enter');
              if (window.innerWidth < 960) {
                const body = document.querySelector('.body');
                body.classList.add('overflow-hidden');
                body.classList.add('position-fixed');
              }
            } else {
              calculator.classList.add('d-none');
              result.classList.remove('d-none');
            }
            finishButton.addEventListener('click', function(e) {
              console.log(e.target.innerHTML);
                if (e.target.innerHTML === 'Close') {
                  openConfirmation('thank-you');
                } else {
                  const email = document.querySelector('[name="email"]');
                  const emailLabel = document.querySelector('.email-label');
                  if (validateEmail(email.value)) {
                    email.classList.remove('error');
                    emailLabel.classList.remove('error');
                    sendEmail()
                      .then(result => {
                        openConfirmation('email');
                      })
                      .catch(error => console.log('Error:', error));
                  } else {
                    email.classList.add('error');
                    emailLabel.classList.add('error');
                  }
                }
            });
            printButton.addEventListener('click', function(e) {
              printHTML();
            });
        } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    });
    
    const resetButton = document.querySelector('.btn-reset');
    resetButton.addEventListener('click', (e) => {
      e.preventDefault();
      openConfirmation('reset');
    })
}
